<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="520"
    @keydown.passive.enter='doDelete'
    @keydown.passive.esc='$emit("cancel")'
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure want to delete<br>the
        <span v-if="item.type == 'rack'">rack "{{item.original.label}}"</span>
        <span v-else-if="item.type == 'shelf'">shelf "{{item.original.label}}"</span>
        <span v-else>bin "{{item.original.label}}"</span>
        ?
      </v-card-title>

      <v-card-text v-if="item.type == 'rack' || item.type == 'shelf'">
        <p class="text-center">
          <span v-if="item.type == 'rack' && item.original.totalShelves > 0">
            All shelves ({{ item.original.totalShelves }}) and bins ({{ item.original.totalBins }}) in the warehouse rack <span class="red--text">will also be deleted</span>.
          </span>
          <span v-if="item.type == 'shelf' && item.original.totalBins > 0">
            All bins ({{ item.original.totalBins }}) in the warehouse shelf <span class="red--text">will also be deleted</span>.
          </span>
        </p>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="doDelete"
          depressed
          class="save-btn small-size"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarehouseMapPopupDelete',
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    type() {
      if (this.item.rackId && this.item.shelfId) {
        return 'bin'
      } else if (this.item.rackId && !this.item.shelfId) {
        return 'shelf'
      } else {
        return 'rack'
      }
    }
  },
  methods: {
    async doDelete() {
      this.$emit('delete')
    }
  }
}
</script>
